export default __webpack_public_path__ + "static/media/create-campaigns-4.444f759f.png";